<template>
  <div>
    <overall-data></overall-data>
    <h1 class="h2 mt-4">Nyilatkozatok</h1>
    <div class="form-group">
      <b>
        Nyilatkozat a Szerződő tevékenységére és pénzügyi helyzetére, illetve vezető
        tisztségviselőire vonatkozóan.<br /><br />
      </b>
      A Szerződő aláírásra jogosult képviselőjeként ezúton igazolom, hogy:
      <br /><br />
      <div class="form-check mb-4">
        <ValidationProvider name="szerzodes" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="szerzodes"
            name="statements[]"
            value="szerzodes"
            v-model="statements_szerzodes"
          />
        </ValidationProvider>
        <label for="szerzodes" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;a szerződő jelenleg nem rendelkezik élő D&O
          szerződéssel a Colonnade Insurance S.A. Magyarországi Fióktelepénél; és
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="iparag" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="iparag"
            name="statements[]"
            value="iparag"
            v-model="statements_iparag"
          />
        </ValidationProvider>
        <label for="iparag" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;társaságunk semmilyen tevékenységet nem végez a
          következő iparágakban, illetve szolgáltató szektorokban: olaj- és gázipar, gyógyszeripar
          és bio-technológia, megújuló vagy alternatív energiák, sportegyesületek és szervezeteket,
          pénzintézeti illetve pénzügyi felügyeleti engedélyhez kötött tevékenységek; és
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="amerika" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="amerika"
            name="statements[]"
            value="amerika"
            v-model="statements_amerika"
          />
        </ValidationProvider>
        <label for="amerika" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; társaságunk nem rendelkezik semmilyen eszközzel,
          érdekeltséggel az Amerikai Egyesült Államokban és Kanadában, illetve ezekből az
          országokból származó közvetlen árbevétellel sem; és
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="oroszorszag" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="oroszorszag"
            name="statements[]"
            value="oroszorszag"
            v-model="statements_oroszorszag"
          />
        </ValidationProvider>
        <label for="oroszorszag" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; az általam képviselt társaság/szerződő nem
          rendelkezik sem közvetetten, sem közvetlenül orosz, fehérorosz tulajdonossal vagy
          ellenőrző befolyást gyakorló személlyel (Oroszországban, Fehéroroszországban bejegyzett
          cég, vagy ezen országokban állandó lakcímmel rendelkező magánszemélyek); és az általam
          képviselt társaság/szerződő nem rendelkezik Oroszországban vagy Fehéroroszországban
          bejegyzett társasággal, eszközzel, érdekeltséggel vagy állandó telephellyel; és az általam
          képviselt társaság/szerződő közvetlenül nem értékesít semmilyen terméket, illetve nem
          nyújt semmilyen szolgáltatást orosz, fehérorosz piacra. Az általam képviselt társaság /
          szerződő nem vásárol semmilyen terméket, illetve szolgáltatást orosz, fehérorosz
          személy(ek)től (Oroszországban, Fehéroroszországban bejegyzett cégtől, vagy ezen
          országokban állandó lakcímmel rendelkező magánszemélyektől).
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="kar" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="kar"
            name="statements[]"
            value="kar"
            v-model="statements_kar"
          />
        </ValidationProvider>
        <label for="kar" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; társaságunk jelenlegi és korábbi vezető
          tisztségviselőivel, felügyelő bizottsági tagjaival és vezető állású alkalmazottaival
          szemben korábban nem érvényesítettek kárigényt és nincs tudomásom/tudomásunk olyan
          kárkörülményről, amely a megkötésre kerülő biztosítás fedezeti körébe tartozó kárigényhez
          vezethet.
        </label>
      </div>
      <b
        >Amennyiben a fenti kijelentések bármelyike nem helytálló a Szerződő tekintetében, akkor az
        ajánlattételre és szerződéskötésre ilyen formában nincs lehetőség. Amennyiben a szerződés
        valótlan adatok közlése alapján jön létre, akkor a Biztosító mentesül a szolgáltatási
        kötelezettsége alól.</b
      >
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapFields} from 'vuex-map-fields';
import Select2 from 'v-select2-component';
import OverallData from './components/OverallData';

export default {
  components: {
    Datepicker,
    Select2,
    OverallData,
  },
  data() {
    return {
      karOpened: false,
      szerzodesOpened: false,
      iparagOpened: false,
      amerikaOpened: false,
      oroszorszagrOpened: false,
    };
  },
  computed: {
    ...mapFields([]),
    ...mapFields({
      statements_kar: 'statements.kar',
      statements_szerzodes: 'statements.szerzodes',
      statements_iparag: 'statements.iparag',
      statements_amerika: 'statements.amerika',
      statements_oroszorszag: 'statements.oroszorszag',
    }),
  },
  methods: {
    karClick(e) {
      if (e) e.preventDefault();
      this.karOpened = !this.karOpened;
    },
    szerzodesClick(e) {
      if (e) e.preventDefault();
      this.szerzodesOpened = !this.szerzodesOpened;
    },
    iparagClick(e) {
      if (e) e.preventDefault();
      this.iparagOpened = !this.iparagOpened;
    },
    amerikaClick(e) {
      if (e) e.preventDefault();
      this.amerikaOpened = !this.amerikaOpened;
    },
    oroszorszagClick(e) {
      if (e) e.preventDefault();
      this.oroszorszagrOpened = !this.oroszorszagrOpened;
    },
  },
};
</script>

<style lang="scss" scoped>
$red: #e4002b;
.custom-file-label::after {
  content: 'Kiválasztás' !important;
}

.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select2-selection__arrow {
  height: 38px !important;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}
</style>
